var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeetingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 2.5V5.83333M6.66683 2.5V5.83333M3.3335 9.16667H16.6668M3.3335 5.83333C3.3335 5.39131 3.50909 4.96738 3.82165 4.65482C4.13421 4.34226 4.55814 4.16667 5.00016 4.16667H15.0002C15.4422 4.16667 15.8661 4.34226 16.1787 4.65482C16.4912 4.96738 16.6668 5.39131 16.6668 5.83333V15.8333C16.6668 16.2754 16.4912 16.6993 16.1787 17.0118C15.8661 17.3244 15.4422 17.5 15.0002 17.5H5.00016C4.55814 17.5 4.13421 17.3244 3.82165 17.0118C3.50909 16.6993 3.3335 16.2754 3.3335 15.8333V5.83333Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 12.5H8.33366V14.1667H6.66699V12.5Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingIcon);
export default __webpack_public_path__ + "static/media/meeting-icon.fda6d79292047863a0e516c22a1494c9.svg";
export { ForwardRef as ReactComponent };